import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from 'cvlib';
import { useDispatch, useSelector } from 'react-redux';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { useNavigate } from 'react-router-dom';
import { GetRegion } from 'constants.js';
/* import {
  pushEvent,
  EVENTS,
  CATEGORY,
  ACTIONS,
} from 'containers/Player/utils/analytics'; */
import { hidePinForm } from './actions/pinForm.actions';
import { getTranslation } from 'utils/getTranslation';

import CheckPinForm from './components/CheckPinForm';
import CreatePinForm from './components/CreatePinForm';
import EmailAlertModal from './components/EmailAlertModal';
import ErrorModal from './components/ErrorModal';
import DecideNewPin from './components/DecideNewPin';
import CallCenterModal from './components/CallCenterModal';
import RecoveryPinForm from './components/RecoveryPinForm';
import { MobileGenericHeader } from 'components/MobileGenericHeader';
import './pinForm.scss';
import { z_index } from 'const/zIndex';

const PinFormContainer = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pinForm = useSelector(state => state.PinForm);
  const assets = useSelector(state => state.asset);
  const reduxZIndex = useSelector(state => state.Player.Modals.zIndex);
  const [modalIndex, setModalIndex] = useState(reduxZIndex);
  const [isOpen, setIsOpen] = useState(pinForm?.show);
  const { firstNode } = useMenuRedirect();
  const { isMobile } = useVerifyIsMobile();
  const translations = useSelector(state => state.translations);
  const epgTransactions = useSelector(
    state => state.Player.EpgTransactions.epgTransactions,
  );
  useEffect(
    () => {
      if (isOpen !== pinForm?.show && !epgTransactions?.isOpen) {
        setIsOpen(pinForm?.show);
      }
      if (pinForm?.show && !epgTransactions?.isOpen) {
        setModalIndex(reduxZIndex);
      }
    },
    [pinForm?.show, epgTransactions?.isOpen],
  );

  const formToShow = () => {
    switch (pinForm.type) {
      case 'EMAIL_SENT':
        return <EmailAlertModal />;
      case 'DECIDE_NEW_PIN':
        return <DecideNewPin />;
      case 'CREATE_NEW_PIN':
        return <CreatePinForm {...pinForm} />;
      case 'SET_PIN_CHANNEL':
      case 'UNBLOCK_CHANNEL':
        return <CheckPinForm {...pinForm} />;
      case 'PIN_RECOVERY':
        return <RecoveryPinForm />;
      case 'CALL_CENTER':
        return <CallCenterModal />;
      case 'ERROR':
        return <ErrorModal {...pinForm} />;
      default:
        return null;
    }
  };

  return useMemo(
    () => (
      <Modal
        isOpen={isOpen}
        zIndex={z_index?.pinForm}
        backgroundStyle={
          pinForm?.type === 'DECIDE_NEW_PIN' ? { backgroundColor: 'black' } : {}
        }
      >
        {pinForm?.type === 'DECIDE_NEW_PIN' && (
          <>
            {isMobile ? (
              <MobileGenericHeader
                caption={getTranslation(
                  'setupPin_modal_title_label',
                  translations,
                )}
                onBack={() => dispatch(hidePinForm())}
              />
            ) : (
              <header className="decideHeader">
                <a
                  href={`/${GetRegion()}/${firstNode}`}
                  onClick={event => {
                    event.preventDefault();
                    navigate(`/${GetRegion()}/${firstNode}`);
                  }}
                >
                  <img src={assets.landing_head_logoClarovideo} alt="logo" />
                </a>
              </header>
            )}
          </>
        )}
        <div className="formContainer">{formToShow()}</div>
      </Modal>
    ),
    [isOpen, pinForm?.type, firstNode],
  );
};

export default PinFormContainer;
